import { render, staticRenderFns } from "./zhuce.vue?vue&type=template&id=a6aa339c&scoped=true"
import script from "./zhuce.vue?vue&type=script&lang=js"
export * from "./zhuce.vue?vue&type=script&lang=js"
import style0 from "./zhuce.vue?vue&type=style&index=0&id=a6aa339c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6aa339c",
  null
  
)

export default component.exports